import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

type Props = {
  value?: string;
  radius?: string;
  onChange: (next: { city: string; radius: string }) => void;
};

export default function CitySelector({ value = "", radius = "10", onChange }: Props) {
  return (
    <div className="flex gap-2 w-full max-w-md">
      <Input
        value={value}
        onChange={(e) => onChange({ city: e.target.value, radius })}
        placeholder="Enter city"
        aria-label="City"
      />
      <Select value={radius} onValueChange={(v) => onChange({ city: value, radius: v })}>
        <SelectTrigger className="w-[140px]"><SelectValue placeholder="Radius" /></SelectTrigger>
        <SelectContent>
          {["5","10","25","50","100"].map((r) => (
            <SelectItem key={r} value={r}>{r} mi</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
